import { FunctionComponent } from 'react';
import styles from './LeadTabPlaceholder.module.scss';

interface LeadTabPlaceholderProps {
    tabLabel: string;
}

const LeadTabPlaceholder: FunctionComponent<LeadTabPlaceholderProps> = ({ tabLabel }) => (
    <div className={styles.root}>
        <p className={styles.title}>{tabLabel} coming soon</p>
        <p className={styles.subtitle}>This section isn&apos;t available yet.</p>
    </div>
);

export default LeadTabPlaceholder;
